import React, { useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { FaMicrophone, FaPlay } from "react-icons/fa";
import { IoCloseSharp, IoSearch } from "react-icons/io5";
import image1 from "../Images/SearchImage/8974e24343427b63e42f0a7e79a361d1_1920x1080.png";
import image2 from "../Images/SearchImage/ishu.png";
import image3 from "../Images/SearchImage/broo.png";
import image4 from "../Images/SearchImage/test_pic1665887782006.png";
import image5 from "../Images/SearchImage/test_pic1666161953734.png";
import image6 from "../Images/SearchImage/test_pic1667363500555.png";
import image7 from "../Images/SearchImage/test_pic1680757863960.png";
import image8 from "../Images/SearchImage/test_pic1691394507361_badged_1726722023489 (1).png";
import image9 from "../Images/SearchImage/test_pic1691394507361_badged_1726722023489.png";
import image10 from "../Images/SearchImage/test_pic1691531811908_badged_1729659609601.png";
import image11 from "../Images/SearchImage/test_pic1706687651988_badged_1720936337850.png";
import image12 from "../Images/SearchImage/test_pic1707985297023_badged_1729746009825.png";
import image13 from "../Images/SearchImage/test_pic1725879654411_badged_1726808415924.png";
import image14 from "../Images/SearchImage/test_pic1725885519983_badged_1726808412651.png";
import image15 from "../Images/SearchImage/test_pic1726299399523.png";
import image16 from "../Images/SearchImage/test_pic1729516247250_badged_1729516263984.png";
import image17 from "../Images/SearchImage/test_pic1730627638567.png";
import image18 from "../Images/SearchImage/test_pic1730983285195.png";
import image19 from "../Images/SearchImage/test_pic1731378557873.png";
import image20 from "../Images/SearchImage/test_pic1731651307610_badged_1731733209724.png";
import { CiCirclePlus } from "react-icons/ci";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { NavLink } from "react-router-dom";

const SearchPage = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const images = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
    image20,
  ];

  return (
    <>
      <div className="sc_input-container p-3 my-4">
        <NavLink to={"/home"}>
          <IoCloseSharp className="sc_close fs-25" />
        </NavLink>
        <div className="hstack gap-2">
          <IoSearch className="text-white fs-25" />
          <div className="w-100">
            <Form.Control
              type="text"
              placeholder="Search for a Web Shows, Movie & Genre etc"
              className="border-0 text-white"
              style={{ backgroundColor: "#0c1b24" }}
            />
          </div>
          <div className="voice-search-container text-end text-white">
            <FaMicrophone className="fs-25" />
          </div>
        </div>
      </div>
      <Container fluid>
        <Row>
          <Form.Group as={Col} md={3} className="text-center">
            <div className="card bg-dark text-white border-0">
              <div className="cardImageone card-body p-4">
                <h5 className="card-title">WEB SHOWS</h5>
              </div>
            </div>
          </Form.Group>
          <Form.Group as={Col} md={3} className="text-center">
            <div className="card bg-dark text-white border-0">
              <div className="cardImagetwo card-body p-4">
                <h5 className="card-title">MOVIES</h5>
              </div>
            </div>
          </Form.Group>
          <Form.Group as={Col} md={3} className="text-center">
            <div className="card bg-dark text-white border-0">
              <div className=" cardImagethree card-body p-4">
                <h5 className="card-title">SHORT FILMS</h5>
              </div>
            </div>
          </Form.Group>
          <Form.Group as={Col} md={3} className="text-center">
            <div className="card bg-dark text-white border-0">
              <div className="cardImagefour card-body p-4">
                <h5 className="card-title">LIVE TV</h5>
              </div>
            </div>
          </Form.Group>
        </Row>
      </Container>
      <Container fluid className="p-0">
        <h4 className="text_light fw-bold p-3">Today Top Searches</h4>
        <div
          className="image-container"
          style={{ height: "calc(100vh - 322px", overflowX: "hidden" }}
        >
          <div className="px-3">
            <div className="hstack gap-2 flex-wrap">
              {images.map((image, index) => (
                <div
                  className="image-card position-relative"
                  key={index}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <img
                    src={image}
                    alt={`image${index + 1}`}
                    className="rounded-3"
                  />
                  {hoveredIndex === index && (
                    <div
                      className="popover-card position-absolute zoom "
                      style={{
                        top: "0%",
                        left: "3%",
                        zIndex: 99,
                      }}
                    >
                      <Card className="text-white bg-dark">
                        <img
                          src={image}
                          alt={`hoveredImage${index + 1}`}
                          className="hover-image rounded-3"
                        />
                        <Card.Body>
                          <div className="mb-2 hstack gap-2 justify-content-between">
                            <Button>
                              <FaPlay className="mx-1" /> Play
                            </Button>
                            <span>02:29 Hrs</span>
                            <div className="text-white">
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-add-watchlist">
                                    Add To My WatchList
                                  </Tooltip>
                                }
                              >
                                <span>
                                  <CiCirclePlus
                                    className="mx-1"
                                    style={{
                                      height: 32,
                                      width: 24,
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </OverlayTrigger>
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip-more-details">
                                    More Details
                                  </Tooltip>
                                }
                              >
                                <span>
                                  <IoIosInformationCircleOutline
                                    className="mx-1"
                                    style={{
                                      height: 32,
                                      width: 24,
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </OverlayTrigger>
                            </div>
                          </div>
                          <Card.Title className="text-white">
                            Armaan's Thoughts On Winter
                          </Card.Title>
                          <Card.Text className="text-white fs-10">
                            Reality TV, Entertainment, Web Series
                          </Card.Text>
                          <Badge bg="secondary" className="p-2 px-3">
                            A
                          </Badge>
                        </Card.Body>
                      </Card>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default SearchPage;
